import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";
import { applyTheme, getInitialTheme } from "./lib/theme.js";
import { initDemoFromUrl } from "./lib/demo.js";
import "./styles/global.css";

applyTheme(getInitialTheme());
// Demo overlay is URL-driven only (?demo=1 on, ?demo=0 off); no visible control.
initDemoFromUrl();

const root = document.getElementById("root");
if (!root) throw new Error("root element missing");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
